const getters = {
	token: state => state.user.token,
	roles: state => state.user.roles,
	user:state=>state.user.user
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js